











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {EmailDestinatario} from '@/model/resource/EmailDestinatario'
import {EmailDestinatarioCollection} from '@/model/collection/EmailDestinatarioCollection'
import {ListEmailDestinatarioSchema} from '@/schema/resource/EmailDestinatario/ListEmailDestinatarioSchema'
import {CsvEmailDestinatarioSchema} from '@/schema/resource/EmailDestinatario/CsvEmailDestinatarioSchema'

@Component
export default class ListEmailDestinatarioView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListEmailDestinatarioSchema()
  collection = new EmailDestinatarioCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: EmailDestinatario) {
    Helper.pushByName('editEmailDestinatario', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new EmailDestinatarioCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvEmailDestinatario()
    new CsvEmailDestinatarioSchema().downloadCsv(csv.all())
  }
}
